import React from "react";
import Routing from "./routing/Routing";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { LanguageSwitcher } from './components/LanguageSwitcher';

const App = () => {
  return (
    <>
      <Routing />
      {/* <LanguageSwitcher /> */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default App;
